import { isCssWideKeyword } from './css-wide-keywords';
import { containsTokenReferenceSyntax, isBareUtilityIdentifier, isNumericUtilityLiteral, } from './utility-value-syntax';
const NEGATIVE_SPACING_ALLOWED_PROPS = new Set([
    'margin',
    'marginX',
    'marginY',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginStart',
    'marginEnd',
    'spaceX',
    'spaceY',
    'translateX',
    'translateY',
]);
const AUTO_SPACING_ALLOWED_PROPS = new Set([
    'margin',
    'marginX',
    'marginY',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginStart',
    'marginEnd',
]);
function normalizeSpacingPropName(propName) {
    switch (propName) {
        case 'm':
            return 'margin';
        case 'mx':
            return 'marginX';
        case 'my':
            return 'marginY';
        case 'mt':
            return 'marginTop';
        case 'mr':
            return 'marginRight';
        case 'mb':
            return 'marginBottom';
        case 'ml':
            return 'marginLeft';
        case 'ms':
            return 'marginStart';
        case 'me':
            return 'marginEnd';
        case 'p':
            return 'padding';
        case 'px':
            return 'paddingX';
        case 'py':
            return 'paddingY';
        case 'pt':
            return 'paddingTop';
        case 'pr':
            return 'paddingRight';
        case 'pb':
            return 'paddingBottom';
        case 'pl':
            return 'paddingLeft';
        case 'ps':
            return 'paddingStart';
        case 'pe':
            return 'paddingEnd';
        default:
            return propName;
    }
}
function isSupportedSpacingKeyword(propName, value) {
    const normalizedPropName = normalizeSpacingPropName(propName);
    if (isCssWideKeyword(value)) {
        return true;
    }
    if (AUTO_SPACING_ALLOWED_PROPS.has(normalizedPropName) && value === 'auto') {
        return true;
    }
    if ((normalizedPropName === 'gap' || normalizedPropName === 'gapX' || normalizedPropName === 'gapY') && value === 'normal') {
        return true;
    }
    return false;
}
function classifyNumericSpacingValue(propName, normalizedValue) {
    const numericValue = Number(normalizedValue);
    if (Number.isNaN(numericValue)) {
        return { valid: false, reason: 'invalid_type', normalizedValue };
    }
    const normalizedPropName = normalizeSpacingPropName(propName);
    if (numericValue < 0 && !NEGATIVE_SPACING_ALLOWED_PROPS.has(normalizedPropName)) {
        return { valid: false, reason: 'negative_not_allowed', normalizedValue };
    }
    if (!Number.isFinite(numericValue)) {
        return { valid: false, reason: 'invalid_type', normalizedValue };
    }
    return { valid: true, kind: 'numeric', normalizedValue };
}
export function classifySpacingUtilityValue(propName, rawValue) {
    if (rawValue === undefined || rawValue === null) {
        return { valid: false, reason: 'empty' };
    }
    if (typeof rawValue === 'number') {
        const normalizedValue = String(rawValue);
        return isNumericUtilityLiteral(normalizedValue)
            ? classifyNumericSpacingValue(propName, normalizedValue)
            : { valid: false, reason: 'invalid_type', normalizedValue };
    }
    if (typeof rawValue !== 'string') {
        return { valid: false, reason: 'invalid_type' };
    }
    const normalizedValue = rawValue.trim();
    if (normalizedValue.length === 0) {
        return { valid: false, reason: 'empty' };
    }
    if (isNumericUtilityLiteral(normalizedValue)) {
        return classifyNumericSpacingValue(propName, normalizedValue);
    }
    if (containsTokenReferenceSyntax(normalizedValue)) {
        return { valid: false, reason: 'token_reference', normalizedValue };
    }
    if (isBareUtilityIdentifier(normalizedValue)) {
        if (!isSupportedSpacingKeyword(propName, normalizedValue)) {
            return { valid: false, reason: 'unsupported_bare_identifier', normalizedValue };
        }
        return { valid: true, kind: 'keyword', normalizedValue };
    }
    return { valid: true, kind: 'arbitrary', normalizedValue };
}
//# sourceMappingURL=spacing-values.js.map